import { Fragment, useCallback, useMemo } from 'react';
import { HR } from 'foundations-components/transitional/components/HR';
import { getId, isProcessing, isCreatedByUser } from 'find-and-filter-data/views-schema/public';
import { List } from 'foundations-components/transitional/components/List';
import { MoreLinksAccordion, SortableList, sortViews, useNavigationSidebarViewsManager, useCustomViewUserSettings, useTrackViewCompleted } from 'svh-workspace-ui-lib/navigation-sidebar/public';
import { CUSTOM_VIEW } from '../constants/dragAndDropTypes';
import { InboxNavViewLink } from './InboxNavViewLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Divider = ({
  testId
}) => {
  return /*#__PURE__*/_jsx(HR, {
    "data-test-id": testId,
    distance: "small",
    marginInline: "300",
    inlineSize: "auto",
    display: "flex"
  });
};
Divider.displayName = 'Divider';
const NavSidebarLinksListInbox = ({
  views,
  handleEditViewClick,
  handleDeleteViewClick,
  userId,
  inboxId,
  viewId,
  hasCustomViewsAccess,
  handleSortTracking,
  handleViewMemberClick,
  handleTrackViewTracking,
  HandleNewFeatureTourStep
}) => {
  const {
    primaryViews,
    collapsedViews,
    userGeneratedViews
  } = useNavigationSidebarViewsManager(views);
  const {
    order,
    loading,
    updateOrder
  } = useCustomViewUserSettings(inboxId);
  const orderedUserGeneratedViews = useMemo(() => sortViews(userGeneratedViews, order), [order, userGeneratedViews]);
  const handleSort = useCallback(updatedOrder => {
    updateOrder(updatedOrder);
    handleSortTracking();
  }, [handleSortTracking, updateOrder]);
  useTrackViewCompleted(userGeneratedViews, userId, handleTrackViewTracking);
  const renderNavLink = useCallback(view => {
    const hideProcessingView = isProcessing(view) && !isCreatedByUser(view, userId);
    if (hideProcessingView) {
      return null;
    }
    const id = getId(view);
    return /*#__PURE__*/_jsx(InboxNavViewLink, {
      // @ts-expect-error sortKey is required for children of SortableList
      sortKey: id,
      handleDeleteViewClick: handleDeleteViewClick,
      handleEditViewClick: handleEditViewClick,
      handleViewMemberClick: handleViewMemberClick,
      view: view,
      viewId: viewId,
      hasCustomViewsAccess: hasCustomViewsAccess
    }, id);
  }, [handleEditViewClick, handleDeleteViewClick, handleViewMemberClick, hasCustomViewsAccess, viewId, userId]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [HandleNewFeatureTourStep ? /*#__PURE__*/_jsx(HandleNewFeatureTourStep, {
      children: /*#__PURE__*/_jsx(List, {
        "data-test-id": "primary-views",
        wrapChildren: true,
        children: primaryViews.map(renderNavLink)
      })
    }) : /*#__PURE__*/_jsx(List, {
      "data-test-id": "primary-views",
      wrapChildren: true,
      children: primaryViews.map(renderNavLink)
    }), collapsedViews.length ? /*#__PURE__*/_jsx(MoreLinksAccordion, {
      currentViewId: viewId,
      views: collapsedViews,
      viewRenderer: renderNavLink
    }) : null, orderedUserGeneratedViews.length ? /*#__PURE__*/_jsx(Divider, {
      testId: 'user-generated-view-divider'
    }) : null, /*#__PURE__*/_jsx("div", {
      "data-test-id": "user-generated-views",
      children: /*#__PURE__*/_jsx(SortableList, {
        listId: "user-generated-views-list",
        listItemType: CUSTOM_VIEW,
        loading: loading,
        onSort: handleSort,
        children: orderedUserGeneratedViews.map(renderNavLink)
      })
    })]
  });
};
NavSidebarLinksListInbox.displayName = 'NavSidebarLinksListInbox';
export default NavSidebarLinksListInbox;